import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
import(/* webpackMode: "eager" */ "/app/src/components/Footer/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/home/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/ResetSidebarItems.tsx")